export default [
  {
    "id": "Allergy & Immunology",
    "total" : 4898,
    "female": 2009,
    "male": 2889
  },
  {
    "id": "Anatomical/clinical pathology",
    "total" : 12634,
    "female": 4860,
    "male": 7774
  },
  {
    "id": "Anesthesiology",
    "total" : 42223,
    "female": 10948,
    "male": 31275
  },
  {
    "id": "Cardiovascular disease",
    "total" : 22502,
    "female": 3356,
    "male": 19146
  },
  {
    "id": "Child & adolescent psychiatry",
    "total" : 9782,
    "female": 5282,
    "male": 4500
  },
  {
    "id": "Critical care medicine",
    "total" : 13076,
    "female": 3508,
    "male": 9568
  },
  {
    "id": "Dermatology",
    "total" : 12505,
    "female": 6372,
    "male": 6133
  },
  {
    "id": "Emergency medicine",
    "total": 45169,
    "female": 12787,
    "male": 32382
  },
  {
    "id": "Endocrinology, diabetes & metabolism",
    "total": 7982,
    "female": 4092,
    "male": 3890
  },
  {
    "id": "Family medicine/general practice",
    "total" : 118022,
    "female": 48693,
    "male": 69329
  },
  {
    "id": "Gastroenterology",
    "total" : 15450,
    "female": 2916,
    "male": 12534
  },
  {
    "id": "General surgery",
    "total" : 25544,
    "female": 5629,
    "male": 19915
  },
  {
    "id": "Geriatric medicine",
    "total" : 5988,
    "female": 3213,
    "male": 2775
  },
  {
    "id": "Hematology & oncology",
    "total" : 16255,
    "female": 5582,
    "male": 10673
  },
  {
    "id": "Infectious disease",
    "total" : 10573,
    "female": 4964,
    "male": 5609
  },
  {
    "id": "Internal medicine",
    "total" : 119961,
    "female": 46401,
    "male": 73560
  },
  {
    "id": "Internal medicine/pediartrics",
    "total" : 5507,
    "female": 2926,
    "male": 2581
  },
  {
    "id": "Interventional cardiology",
    "total": 4399,
    "female": 350,
    "male": 4049
  },
  {
    "id": "Neonatal-prenatal medicine",
    "total": 5915,
    "female": 3126,
    "male": 2789
  },
  {
    "id": "Nephrology",
    "total": 6085,
    "female": 3296,
    "male": 2789
  },
  {
    "id": "Neurological surgery",
    "total": 5744,
    "female": 537,
    "male": 5207
  },
  {
    "id": "Neurology",
    "total": 14132,
    "female": 4363,
    "male": 9769
  },
  {
    "id": "Obstetrics & gynecology",
    "total": 42683,
    "female": 25160,
    "male": 17523
  },
  {
    "id": "Opthalmology",
    "total": 19662,
    "female": 5146,
    "male": 14516
  },
  {
    "id": "Orthopedic surgery",
    "total": 19064,
    "female": 1099,
    "male": 17965
  },
  {
    "id": "Otolaryngology",
    "total": 9771,
    "female": 1784,
    "male": 7987
  },
  {
    "id": "Pain medicine & pain management",
    "total": 5858,
    "female": 1113,
    "male": 4745
  },
  {
    "id": "Pediatric cardiology",
    "total": 2962,
    "female": 1098,
    "male": 1864
  },
  {
    "id": "Pediatric hematology/oncology",
    "total": 3076,
    "female": 1695,
    "male": 1381
  },
  {
    "id": "Pediatrics",
    "total": 60565,
    "female": 38923,
    "male": 21642
  },
  {
    "id": "Physical medicine & rehabilitation",
    "total": 9740,
    "female": 3486,
    "male": 6254
  },
    {
    "id": "Plastic surgery",
    "total": 7314,
    "female": 1261,
    "male": 6053
  },
    {
    "id": "Preventive medicine",
    "total": 6671,
    "female": 2349,
    "male": 4322
  },
    {
    "id": "Psychiatry",
    "total": 38770,
    "female": 15571,
    "male": 23199
  },
    {
    "id": "Pulmonary disease",
    "total": 5105,
    "female": 627,
    "male": 4478
  },
    {
    "id": "Radiation oncology",
    "total": 5303,
    "female": 1455,
    "male": 3848
  },
    {
    "id": "Radiology & diagnostic radiology",
    "total": 28008,
    "female": 7413,
    "male": 20595
  },
    {
    "id": "Rheumatology",
    "total": 6252,
    "female": 2892,
    "male": 3360
  },
    {
    "id": "Sports medicine (orthopedic surgery)",
    "total": 2903,
    "female": 201,
    "male": 2702
  },
    {
    "id": "Thoracic surgery",
    "total": 4479,
    "female": 360,
    "male": 4119
  },
    {
    "id": "Urology",
    "total": 9586,
    "female": 360,
    "male": 9226
  },
    {
    "id": "Vascular & interventional radiology",
    "total": 3415,
    "female": 325,
    "male": 3090
  },
    {
    "id": "Vascular surgery",
    "total": 3686,
    "female": 482,
    "male": 3204
  }
]